import BaseUICCustomerListView from 'xui/modules/contact/BaseUICCustomerListView'

class CCustomerListView extends BaseUICCustomerListView {
  static displayName = 'CCustomerListView'
}

export default CCustomerListView
